import { ENVIRONMENT } from "./EnvConfig";
import { getAmHost } from "../../web/src/Utils/utils";
import { lookerSteps } from "./looker-steps"

export const API_URL = "https://stoplight.io/mocks/brightspeed-apiverse/";
export const SMARTY_STREET_ADDRESS_URL =
  "https://us-autocomplete-pro.api.smartystreets.com/lookup?key=117559863585036761&license=us-autocomplete-pro-cloud&search=";
export const LOCALHOST_SMARTY_STREET_ADDRESS_URL =
  "https://us-autocomplete-pro.api.smartystreets.com/lookup?auth-id=075fdb94-1a3c-8165-b16f-d8428e11428e&auth-token=93d2qjdBKGgCLF3klTlV&search=";
export const VALIDATE_ADDRESSS_GET_LAT_LOG =
  "https://us-street.api.smartystreets.com";
export const FB_FIELDS = "id,email,name,first_name,middle_name,last_name";


function isProd() {
  return (
    process.env.REACT_APP_ENV === "production" ||
    process.env.NODE_ENV === ENVIRONMENT.production
  );
}

function isUAT() {
  return (
    process.env.REACT_APP_ENV === "uat" ||
    process.env.NODE_ENV === ENVIRONMENT.uat
  );
}

export const watsonSearchEnviromentKeys = {
  base_url:
    "https://api.us-east.discovery.watson.cloud.ibm.com/instances/e19b336c-e6f2-4450-9afc-ed6829c84251",
  environment_id: "333e1bdb-87f4-4e80-b0e5-58b828f8f49b",
  collection_id: "3443f1b4-4bd0-405e-b098-e9ff06552b51",
  query_version: "2023-03-31",
  returnType:
    "extracted_metadata.file_type,extracted_metadata.title,metadata.source.url,text",
  tokenType: "Basic",
};

export const contentApiParams = (param) => {
  return {
    [param.page]: `entries/${param.key}${
      !isProd() ? "?environment=development" : "?environment=production"
    }`,
  };
};

// in web we are using this object for setting refreshToken
export const webRefreshTokenRedux = {};

export const EC_DW_LOGGING_STEPS = lookerSteps;

export const notificationType = {
  creditCard: "CreditCard",
  buryCable: "BuryCable",
  acpBanner: "ACPBanner",
  paymentExpired: "suspend",
  vacationSuspend: "VacationSuspend",
  roadBore: "RoadBore",
  userSuspended: "Suspend",
  nopaymentmethod: "nopaymentmethod",
  changePlanPending: "changePlanPending",
  installationExtend:"InstallationExtendBanner"
};

export const companyNameofQF = [
  "QUANTUM FIBER",
  "QF",
  "QF-II",
  "QUANTUM FIBER II",
  "CENTURY LINK",
  "CTL",
];


// SENSITIVE ITEM
export const CONST_VALUES = {
  account_lock: "ACCOUNT LOCKED",
  customer_id_key: process.env.REACT_APP_CUSTOMER_ID_KEY,
  account_enabled_message_key: process.env.REACT_APP_ACCOUNT_ENABLED_MESSAGE_KEY,
  emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  new_customer: "CTL",
  old_customer: "CENTURY LINK",
  lastLoginBanKey: process.env.REACT_APP_LAST_LOGIN_BAN_KEY
};


// Need API to move from File
export const publicKeySpeedPay = process.env.REACT_APP_PUBLIC_KEY_SPEEDPAY



export const THIC= "protection"
export const WIFI_EXTENDER= "extender"
export const WHOLE_HOME_WIFI= "Whole Home WiFi"
export const WIFI_EXTENDER_SHORT= "WiFi ext"
export const THIC_LAUNCH_DATE= (getAmHost()==="BAU_QA2" || getAmHost()==="NEXT_QA2")?"2025-02-1":"2025-04-11"
